module.exports = __webpack_public_path__ + "img/blackjack.8e4522cd.png";